module.exports = __webpack_public_path__ + "media/images/vuma-logo-db40276f31087dcd805f9d45fb23b6bd.png";